/* Built In Imports */

/* External Imports */
import { Flex, Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SimpleButton from '@components/Buttons/SimpleButton';

/* Services */

const EarlyBird = ({ section, region, lang }) => {
  const sectionContent = section?.sectionContent;
  return (
    <MidContainer>
      <Flex width="100%" h="auto" alignItems="center" justifyContent="center">
        <SimpleButton
          style={sectionContent[0]}
          bType={sectionContent[0].sectionId}
          region={region}
          lang={lang}
          mb="10px"
          mt="40px"
          // width="180px"
          textAlign="center"
        />
      </Flex>
      <Box
        fontSize={{
          base: '16px',
          md: '16px',
        }}
        width="58%"
        fontFamily="FedraSansStd-book"
        fontWeight="500"
        textTransform="uppercase"
        m="0 auto"
        color="#CF4520"
      >
        <StructuredTextParser
          str={render(sectionContent[1]?.body)}
          region={region}
          lang={lang}
          mt="0"
          mb="50px"
          textAlign="center"
        />
      </Box>
    </MidContainer>
  );
};

export default EarlyBird;
